import { useEffect } from "react";

import { useSelector } from "react-redux";
import IdleTimer from "./idleTimer";
import { removeAllModals } from "./removeAllModals";

let Secure;

const protectPage = (WrappedComponent) => {
  return (Secure = () => {
    const loggedInUser = useSelector(
      (state) => state?.authReducer?.loggedInUser
    );

    useEffect(() => {
      if (loggedInUser?.sso_auth_token) {
        const timeoutDuration = process.env.NODE_ENV === "development" ? 1800 : 300; // 30 mins in development, 5 mins in production
        const timer = new IdleTimer({
          timeout: timeoutDuration,
          onTimeout: () => {
            alert("Your session timed out.");
            removeAllModals();
            localStorage.clear();
            window.location.replace("/login");
          },
        });

        return () => {
          timer.cleanup();
        };
      }
    }, [loggedInUser?.sso_auth_token]);

    return (
      <div className="p-3" style={{ minHeight: "90vh" }}>
        <WrappedComponent />
      </div>
    );
  });
};

export default protectPage;
